import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const emailPhoneValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const pattern = /^(?:(?:07(?:\s*\d){8}\s*)|(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+))$/;
  const valid = pattern.test(control.value);
  return valid ? null : { emailPhone: true };
};
